import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";

import Layout from "./components/layout/layout";
import AddLink from "./pages/admin-dashboard/addlink/addlink";
import UserDetails from "./pages/admin-dashboard/userdetails/user-details";
import AddCertificate from "./pages/admin-dashboard/addcertificate/addcertificate";
import TransactionDetails from "./pages/admin-dashboard/transactiondetails/transactiondetails";
import BulkUploadCertificates from "./pages/admin-dashboard/addcertificate/bulkuploadcertificate";

import AddMember from "./pages/admin-dashboard/memberdetails/addmember";
import BulkUploadMember from "./pages/admin-dashboard/memberdetails/bulkuploadmember";
import LoginPage from "./pages/login/login";
import LeftpanelMember from "./components/leftpanel/left-panel-admin";
import HeaderPart from "./components/layout/header-admin/header";
import AfterLoginDashboard from "./pages/admin-dashboard/dashboard/dashboard";
import CalendarEvents from "./pages/admin-dashboard/calendar-events/calendar-events";
import ViewLink from "./pages/admin-dashboard/view-link/view-link";
import WixTemplate from "./pages/admin-dashboard/add-resources/wix-template/wix-template";
import ShareableImages from "./pages/admin-dashboard/add-resources/shareable-images/shareable-images";
import CertificateGuide from "./pages/admin-dashboard/add-resources/certificate-guide/certificate-guide";
import Faqs from "./pages/admin-dashboard/add-resources/faqs/faqs";
import UserDetailsTvi from "./pages/admin-dashboard/userdetails/user-details-tvi";
import AddAffiliates from "./pages/admin-dashboard/affiliates/add-affiliates";
import UserDetailsAffiliates from "./pages/admin-dashboard/userdetails/user-details-affiliates";
import AddNavigation from "./pages/admin-dashboard/navigation/AddNavigation";
import EditNavigation from "./pages/admin-dashboard/navigation/EditNavigation";
import DeleteNavigation from "./pages/admin-dashboard/navigation/DeleteNavigation";
import CommissionPlan from "./pages/admin-dashboard/affiliates/commission-plan";
import AffiliateTransactionDetails from "./pages/admin-dashboard/affiliates/transaction-details";
import AffiliateMemberDetails from "./pages/admin-dashboard/affiliates/affiliate-member-details";
import CreatePdf from "./pages/admin-dashboard/addcertificate/create-pdf";
import TravelCertificateDetails from "./pages/admin-dashboard/addcertificate/TravelCertificateDetails";

import CommissionReportDetails from "./pages/admin-dashboard/affiliates/commission-report";
import RedeemCertificates from "./pages/admin-dashboard/addcertificate/RedeemCertificates";
import PartnerSection from "./pages/admin-dashboard/add-resources/partner/partner";
import ActiveCertificateCode from "./pages/admin-dashboard/addcertificate/activecertificate";
import VilocityCommissionSet from "./pages/admin-dashboard/affiliates/vilocity-commission";
import UserChangeAffiliate from "./pages/admin-dashboard/affiliates/affiliate-user-change";
import LimitCertificate from "./pages/admin-dashboard/addcertificate/limit-certificate";
import TVIMembersActivePlan from "./pages/reports/TVIMembersActivePlan";
import TVIMemberCertificateSend from "./pages/reports/TVIMemberCertificateSend";
import TVIMemberCertificateRedeemed from "./pages/reports/TVIMemberCertificateRedeemed";
import AnniversaryReports from "./pages/reports/AnniversaryReports";
import TVActiveMemberReports from "./pages/reports/TVActiveMemberReports";
import TVIActiveMemberReports from "./pages/reports/TVIActiveMemberReports";
import ActiveReferralReports from "./pages/reports/ActiveReferralReports";
import SubscriptionCanceledReports from "./pages/reports/SubscriptionCanceledReports";
import PlanWiseAllMembers from "./pages/reports/PlanWiseAllMembers";
import TVMembersActivePlan from "./pages/reports/TVMembersActivePlan";
import MemberList from "./pages/admin-dashboard/memberdetails/MemberList";
import CertificateList from "./pages/admin-dashboard/addcertificate/CertificateList";
import AddPreferredPartners from "./pages/admin-dashboard/add-resources/partner/AddPreferredPartners";
import SendCertificate from "./pages/admin-dashboard/addcertificate/SendCertificate";
import CorporateUserList from "./pages/admin-dashboard/userdetails/corporate-user-list";
import CorporateMember from "./pages/admin-dashboard/userdetails/corporate-member-list";
import AddEscapeBucksProduct from "./pages/admin-dashboard/escape-bucks/AddEscapeBucksProduct";
import AddEscapeBucksProductCategory from "./pages/admin-dashboard/escape-bucks/AddEscapeBucksProductCategory";
import GenerateCodeEscapeBucksProduct from "./pages/admin-dashboard/escape-bucks/GenerateCodeEscapeBucksProduct";
import RedeemCommisionEscapeBucksProduct from "./pages/admin-dashboard/escape-bucks/RedeemCommisionEscapeBucksProduct";
import EscapeTipsRedeemCommission from "./pages/admin-dashboard/escape-bucks/escapeTipsRedeemCommission";
import EscapeDollarCount from "./pages/admin-dashboard/escape-bucks/EscapeDollarCount";
import VIPUserList from "./pages/admin-dashboard/userdetails/VIPUserList";
import VipMemberTransactionHistory from "./pages/admin-dashboard/userdetails/VipMemberTransactionHistory";
import AddCorporateClient from "./pages/corporate-clients/AddCorporateClient";
import ClientWiseMemberReport from "./pages/reports/clientWiseMemberReport";
import CorporateInvoice from "./pages/corporate-clients/CorporateInvoice";
import AllCorporateMemberList from "./pages/admin-dashboard/userdetails/all-member-list";
import CorporateGraphics from "./pages/corporate-clients/CorporateGraphics";
import ClientWiseMemberUpload from "./pages/corporate-clients/ClientWiseMemberUpload";
import IgniteCorporateClient from "./pages/corporate-clients/IgniteCorporateClient";

function RouteWrapper({ component: Component, layout: Layout, ...rest }) {
  return (
    <Route
      // {...rest}
      // render={(props) => (
      //   <Layout {...props}>
      //     <Component {...props} />
      //   </Layout>
      // )}
      {...rest}
      render={(props) =>
        localStorage.getItem("AuthToken") ? (
          <Layout {...props}>
            <div>
              <HeaderPart />
              <div className="main_cont">
                <LeftpanelMember />
                <Component {...props} />
                {/* <Footer /> */}
              </div>
            </div>
          </Layout>
        ) : (
          // <>{console.log("No Token")}</>

          <Route exact path="/">
            <LoginPage />
          </Route>
          // <Redirect to="/" />
        )
      }
    />
  );
}

function App() {
  const [token, setToken] = useState(null);
  useEffect(() => {
    if (localStorage.getItem("AuthToken")) {
      setToken(localStorage.getItem("AuthToken"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          {token ? (
            <RouteWrapper
              path="/"
              component={AfterLoginDashboard}
              layout={Layout}
              exact
            />
          ) : (
            <RouteWrapper
              path="/"
              component={LoginPage}
              layout={Layout}
              exact
            />
          )}
          <RouteWrapper path="/" component={LoginPage} layout={Layout} exact />
          <RouteWrapper
            path="/dashboard"
            component={AfterLoginDashboard}
            layout={Layout}
            exact
          />
          <RouteWrapper path="/add-link" component={AddLink} layout={Layout} />
          <RouteWrapper
            path="/certificates"
            component={CertificateList}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/add-certificate"
            component={AddCertificate}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/user-details"
            component={UserDetails}
            layout={Layout}
          />
          <RouteWrapper
            path="/vip-user-list"
            component={VIPUserList}
            layout={Layout}
          />
          <RouteWrapper
            path="/vip-member-transaction-history/:userId"
            component={VipMemberTransactionHistory}
            layout={Layout}
          />
          <RouteWrapper
            path="/transaction-details"
            component={TransactionDetails}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/bulk-upload/:certificate_id?"
            component={BulkUploadCertificates}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/members"
            component={MemberList}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/add-member"
            component={AddMember}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/bulk-upload-member"
            component={BulkUploadMember}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/calendar-events"
            component={CalendarEvents}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/view-link"
            component={ViewLink}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/wix-template"
            component={WixTemplate}
            layout={Layout}
            exact
          />

          <RouteWrapper
            path="/shareable-images"
            component={ShareableImages}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/add-preferred-partner"
            component={AddPreferredPartners}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/preferred-partner"
            component={PartnerSection}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/certificate-guide"
            component={CertificateGuide}
            layout={Layout}
            exact
          />
          <RouteWrapper path="/faqs" component={Faqs} layout={Layout} exact />
          <RouteWrapper
            path="/user-details-tvi"
            component={UserDetailsTvi}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/add-affiliates"
            component={AddAffiliates}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/affiliate-user"
            component={UserDetailsAffiliates}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/add-navigation"
            component={AddNavigation}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/edit-navigation"
            component={EditNavigation}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/delete-navigation"
            component={DeleteNavigation}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/commission-plan"
            component={CommissionPlan}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/affiliate-transaction-details"
            component={AffiliateTransactionDetails}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/affiliate-member-details"
            component={AffiliateMemberDetails}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/edit-affiliate/:id"
            component={UserChangeAffiliate}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/available-certificate"
            component={ActiveCertificateCode}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/create-pdf"
            component={CreatePdf}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/redeem-certificate"
            component={RedeemCertificates}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/send-certificate"
            component={SendCertificate}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/limit-certificate"
            component={LimitCertificate}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/travel-certificate-details/:id"
            component={TravelCertificateDetails}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/commission-report/"
            component={CommissionReportDetails}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/vilocity-commission-set/"
            component={VilocityCommissionSet}
            layout={Layout}
            exact
          />

          {/* REPORTS */}

          <RouteWrapper
            path="/reports-tvi-active-members"
            component={TVIActiveMemberReports}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-tv-active-members"
            component={TVActiveMemberReports}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-tvi-members-active-plan"
            component={TVIMembersActivePlan}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-tvi-members-certificate-send"
            component={TVIMemberCertificateSend}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-client-wise-members-count"
            component={ClientWiseMemberReport}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-tvi-members-certificate-redeemed"
            component={TVIMemberCertificateRedeemed}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-tv-members-active-plan"
            component={TVMembersActivePlan}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/plan-wise-all-members/:source/:packageId"
            component={PlanWiseAllMembers}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-anniversary"
            component={AnniversaryReports}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-active-referral"
            component={ActiveReferralReports}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/reports-subscription-canceled"
            component={SubscriptionCanceledReports}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/tvi-corporate-user-list"
            component={CorporateUserList}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/corporate-member-list/:id"
            component={CorporateMember}
            layout={Layout}
            exact
          />

          {/* ESCAPE BUCKS */}

          <RouteWrapper
            path="/add-escape-bucks-product-categories"
            component={AddEscapeBucksProductCategory}
            layout={Layout}
            exact
          />

          <RouteWrapper
            path="/add-escape-bucks-products"
            component={AddEscapeBucksProduct}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/generate-code-escape-bucks-products"
            component={GenerateCodeEscapeBucksProduct}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/escape-bucks-product-redeem-commision"
            component={RedeemCommisionEscapeBucksProduct}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/escape-tips-redeem-commission"
            component={EscapeTipsRedeemCommission}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/escape-dollar-count"
            component={EscapeDollarCount}
            layout={Layout}
            exact
          />

          {/* CORPORATE CLIENTS */}
          <RouteWrapper
            path="/add-corporate-client"
            component={AddCorporateClient}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/corporate-invoice/:id"
            component={CorporateInvoice}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/corporate-graphics/:id"
            component={CorporateGraphics}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/all-corporate-member-list"
            component={AllCorporateMemberList}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/client-wise-member-upload/:clientId/:tviId"
            component={ClientWiseMemberUpload}
            layout={Layout}
            exact
          />
          <RouteWrapper
            path="/ignite-corporate-client"
            component={IgniteCorporateClient}
            layout={Layout}
            exact
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
